import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import { GB, DE, FR, AU, NZ } from '../../../constants/country-codes';
import React from 'react';

export const EXCEEDINGLY_GROSS_PLATINUM_PLAN_CODE_CONSTANT = 'platinum';

// TODO: Circle back to this in the future to be able to set help url's by both home country and language locale: e.g. US country with spanish language

export const countriesWithAbbreviatedMenus = [FR, AU, DE, NZ, GB];

const phoneSupportUrls = {
  usEnterprisePhoneSupport: 'tel:+1 512 975 3001',
  ukEnterprisePhoneSupport: 'tel:+44 0 208 068 5526',
  ukPlatinumPhoneSupport: 'tel:+44 20 8629 6924',
  auEnterprisePhoneSupport: 'tel:+61 02 8806 1020',
  auPhoneSupport: 'tel:+61 02 9538 7538',
  nzPhoneSupport: 'tel:+64 800 445 643',
};

export const USEnterprisePhoneSupportItem = {
  url: phoneSupportUrls.usEnterprisePhoneSupport,
  description: <FormattedMessage {...messages.usEnterpriseSupport} />,
};
export const CAEnterprisePhoneSupportItem = {
  url: phoneSupportUrls.usEnterprisePhoneSupport,
  description: <FormattedMessage {...messages.usEnterpriseSupport} />,
};
export const GBEnterprisePhoneSupportItem = {
  url: phoneSupportUrls.ukEnterprisePhoneSupport,
  description: <FormattedMessage {...messages.ukEnterpriseSupport} />,
};
export const AUEnterprisePhoneSupportItem = {
  url: phoneSupportUrls.auEnterprisePhoneSupport,
  description: <FormattedMessage {...messages.auEnterpriseSupport} />,
};
export const GBPlatinumPhoneSupportItem = {
  url: phoneSupportUrls.ukPlatinumPhoneSupport,
  description: <FormattedMessage {...messages.ukPlatinumSupport} />,
};
export const NZPhoneSupportItem = {
  url: phoneSupportUrls.nzPhoneSupport,
  description: <FormattedMessage {...messages.nzSupportNumber} />,
};
export const AUPhoneSupportItem = {
  url: phoneSupportUrls.auPhoneSupport,
  description: <FormattedMessage {...messages.auSupportNumber} />,
};

export const enterprisePhoneSupportMap = {
  US: USEnterprisePhoneSupportItem,
  CA: CAEnterprisePhoneSupportItem,
  GB: GBEnterprisePhoneSupportItem,
  AU: AUEnterprisePhoneSupportItem,
};

export const supportPhoneItemTestId = 'support-phone-item';
